import { Component, QueryList, ViewChildren } from '@angular/core';
import { UserService } from '../../services/user.service';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

/**
 * Renders a context menu grid cell.
 */
@Component({
	selector: 'grid-menu-cell-renderer',
	templateUrl: './grid-menu-cell-renderer.component.html',
	styleUrl: './grid-menu-cell-renderer.component.css'
})
export class GridMenuCellRendererComponent implements ICellRendererAngularComp {
	@ViewChildren(NgbDropdown) dropdowns!: QueryList<NgbDropdown>;
	LOCALIZATION: any;
	userPermissions: { [key: string]: any } = {};
	
	mapViewEnabled: boolean = false;
	isMoreLikeThisEnabled: boolean = false;
	cartOn: boolean = false;
	tagsEnabled: boolean = false;
	streamingQueries: { [key: string]: any } = {};

	context: any; // Passed in through the parent gridOptions 
	value: any;
	record: any;

	constructor(
		private userService: UserService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.userPermissions = this.userService.getUserPermissionsMap();
	}

	agInit(params: ICellRendererParams): void {
		this.refresh(params);
	}

	refresh(params: ICellRendererParams): boolean {
		this.value = params.value || [];
		this.record = params?.data || {};
		
		this.context = params.context;
		this.mapViewEnabled = this.context.mapViewEnabled;
		this.isMoreLikeThisEnabled = this.context.isMoreLikeThisEnabled;
		this.cartOn = this.context.cartOn;
		this.tagsEnabled = this.context.tagsEnabled;

		return true;
	}
	
	openInMap(event?: Event): void {
		this.closeAllDropdowns();
		if (event) event.stopPropagation();
		this.context.openInMap(this.record);
	}
	
	viewMetadata(event?: Event): void {
		this.closeAllDropdowns();
		if (event) event.stopPropagation();
		this.context.viewMetadata(this.record.id);
	}
	
	searchSimilarDocs(event?: Event): void {
		this.closeAllDropdowns();
		if (event) event.stopPropagation();
		this.context.searchSimilarDocs(this.record);
	}
	
	addToCart(event?: Event): void {
		this.closeAllDropdowns();
		if (event) event.stopPropagation();
		this.context.addToCart(this.record);
	}
	
	viewTags(event?: Event): void {
		this.closeAllDropdowns();
		if (event) event.stopPropagation();
		this.context.viewTags(this.record);
	}
	
	viewRMQuickInfo(event?: Event): void {
		this.closeAllDropdowns();
		if (event) event.stopPropagation();
		this.context.viewRMQuickInfo(this.record.id);
	}
	
	searchByStreamingQuery(streamingQueryType: string, displayName: string, event?: Event): void {
		this.closeAllDropdowns();
		if (event) event.stopPropagation();
		this.context.searchByStreamingQuery(this.record, streamingQueryType, displayName);
	}	
	closeAllDropdowns(): void {
    	this.dropdowns.forEach(dropdown => dropdown.close());
    }	
}
